//shared/components/chat/ChatWindow.js
import React from "react";
import { Box } from "@mui/material";
import ChatHeader from "./ChatHeader";
import MessageList from "./MessageList";
import MessageInput from "./MessageInput";
import Typography from "@mui/material/Typography";

const ChatWindow = ({
  conversation,
  messages,
  loading,
  messagesEndRef,
  onSendMessage,
  currentUserId,
  isAI,
  onClearHistory,
  isTyping,
}) => {
  if (!conversation) {
    return (
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "grey.50",
        }}
      >
        <Typography color="text.secondary">
          Selecione uma conversa para começar
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <ChatHeader
        user={conversation.user}
        isAI={isAI}
        onClearHistory={onClearHistory}
      />

      <MessageList
        messages={messages}
        loading={loading}
        messagesEndRef={messagesEndRef}
        currentUserId={currentUserId}
        isTyping={isTyping}
      />

      <MessageInput
        onSend={onSendMessage}
        disabled={loading || (isAI && isTyping)}
      />
    </Box>
  );
};

export default ChatWindow;
